import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SettingsPanel from './SettingsPanel';
import ModalWrapper from './ModalWrapper';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose }) => {
  const { t } = useLanguage();

  const footer = (
    <button
      onClick={onClose}
      className="bg-cyan-500/20 text-cyan-300 border border-cyan-500/50 hover:bg-cyan-500/30 px-6 py-2.5 rounded-lg text-sm font-medium transition-colors"
    >
      ✓ {t.saveSettings}
    </button>
  );

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title={`⚙️ ${t.settings}`}
      size="md"
      footer={footer}
    >
      <SettingsPanel showTitle={false} />
    </ModalWrapper>
  );
};

export default SettingsModal;
